<template>
  <div class="rightCircleList flex-col-c-c">
    <div class="circle-list flex-row-c-sb" v-if="this.days!='cus'">
      <div class="cicle-itme flex-row-c-t">
        <img style="width: 40px;" src="~@/assets/large/blue1.gif" alt="">
        <div class="msg">
          <p class="num">{{ kf }}</p>
          <span class="txt">开方量</span>
        </div>
      </div>
      <div class="cicle-itme flex-row-c-t">
        <img style="width: 40px;" src="~@/assets/large/green1.gif" alt="">
        <div class="msg">
          <p class="num">{{ xs }}</p>
          <p class="txt">销售额</p>
        </div>
      </div>
      <div class="cicle-itme flex-row-c-t">
        <img style="width: 40px;" src="~@/assets/large/qingse1.gif" alt="">
        <div class="msg">
          <p class="num">{{
              parseInt(yzs).toLocaleString('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              })
            }}</p>
          <p class="txt">云诊所</p>
        </div>
      </div>
    </div>
    <div class="circle-list" v-else>
      <el-row>
        <el-date-picker
            v-model="date_value"
            @change="request_kf_xs_date_range"
            type="datetimerange"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right">
        </el-date-picker>
      </el-row>
      <el-row style="margin-top: 6px">
        <el-select v-model="query_var" placeholder="请选择变量" style="width: 120px;">
          <el-option label="使用云诊所天数" value="online_mr_count"></el-option>
          <el-option label="使用Pad诊所天数" value="online_by_pad_mr_count"></el-option>
        </el-select>
        <el-select v-model="query_cond" placeholder="请选择条件" style="margin-left:10px;width: 90px;">
          <el-option label="=" value="="></el-option>
          <el-option label=">=" value=">="></el-option>
          <el-option label="<=" value="<="></el-option>
          <el-option label=">" value=">"></el-option>
          <el-option label="<" value="<"></el-option>
        </el-select>
        <el-input placeholder="请输入值" v-model="query_value"
                  style="margin-left:10px;width: 80px;"></el-input>
        <el-button type="success" style=" width: 90px;height: 40px;color:white"
                   @click="request_kf_xs_date_range()">确 定
        </el-button>

      </el-row>

    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";

moment.tz("Asia/Shanghai");
export default {
  name: "RightCircleList",
  props: {
    "days": {
      defaultValue: "-1",
      type: String,
    }
  },
  data() {
    return {
      date_value: [moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
      kf: 0,
      xs: 0,
      yzs: 0,
      query_var: '',
      query_cond: '',
      query_value: '',
      kfxs: {
        kf_all: null,
        xs_all: null,
        yzs_all: null,
        kf_365: null,
        xs_365: null,
        yzs_365: null,
        kf_180: null,
        xs_180: null,
        yzs_180: null,
        kf_30: null,
        xs_30: null,
        yzs_30: null,
        kf_1: null,
        xs_1: null,
        yzs_1: null,
      },
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime());
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
            start.setHours(0, 0, 0, 0)
            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近半年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 182);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '全部',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 3650);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    };
  },
  mounted() {
    this.request_kf_xs();
  },
  methods: {
    request_kf_xs_date_range() {
      this.$store.state.date_value= this.date_value
      this.$store.state.query_flag= new Date()
      this.$store.state.query_var= this.query_var
      this.$store.state.query_cond= this.query_cond
      this.$store.state.query_value= this.query_value

    },
    request_kf_xs() {
      console.log("days:" + this.days)
      this.$http.get(process.env.VUE_APP_API_HOST + "/query_kf_xs").then((res) => {
        this.kfxs = res.data.data.kfxs

        switch (this.days) {
          case "-1":
            this.kf = this.kfxs.kf_all
            this.xs = this.kfxs.xs_all
            this.yzs = this.kfxs.yzs_all
            break;
          case "365":
            this.kf = this.kfxs.kf_365
            this.xs = this.kfxs.xs_365
            this.yzs = this.kfxs.yzs_365
            break;
          case "180":
            this.kf = this.kfxs.kf_180
            this.xs = this.kfxs.xs_180
            this.yzs = this.kfxs.yzs_180
            break;
          case "30":
            this.kf = this.kfxs.kf_30
            this.xs = this.kfxs.xs_30
            this.yzs = this.kfxs.yzs_30
            break;
          case "1":
            this.kf = this.kfxs.kf_1
            this.xs = this.kfxs.xs_1
            this.yzs = this.kfxs.yzs_1
            break;
        }
      })
    },
  },
};
</script>


<style scoped lang='scss'>
.rightCircleList {
  width: 100%;
  // height: 130px;
  color: rgb(185, 183, 183);

  .circle-list {
    padding: 0 10px;

    .cicle-itme {
      flex: 1;
      margin-right: 10px;

      .chart {
        width: 52px;
        height: 52px;
      }

      .msg {
        height: 100%;
        margin-left: 5px;
        display: inline-block;
        flex-direction: column;


        .num {
          font-size: 20px;
          font-weight: bold;
          color: #ffffff;
          white-space: nowrap;
        }

        .txt {
          font-size: 14px;
          color: #ffffff;
          opacity: 0.8;
        }
      }
    }
  }
}
</style>
